import React, { lazy, Suspense, useContext } from 'react';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import PageLoader from '../components/Loader/PageLoader';
import Layout from '../Layout/Layout';
import { ThemeContext } from '../context/ThemeContext';
import ProjectSetupLayout from '../pages/ProjectSetup';
import { LinkProvider } from '../components/ui-x';

/* ui-x renders <UIXLink>; this teaches it what a link is in this app. */
const RouterLink = ({ to, children, ...rest }) =>
  /^(https?:)?\/\//.test(to) || to.startsWith('mailto:') ? (
    <a href={to} {...rest}>
      {children}
    </a>
  ) : (
    <Link to={to} {...rest}>
      {children}
    </Link>
  );

const NotFound = lazy(() => import('../pages/NotFound/NotFound'));
const Overview = lazy(() => import('../pages/Dashboard/Overview'));
const Invites = lazy(() => import('../pages/Dashboard/Invites'));
const HireRequests = lazy(() => import('../pages/Dashboard/HireRequests'));
const Profile = lazy(() => import('../pages/Profile/Profile'));
const Project = lazy(() => import('../pages/Project/Project'));
const JobPost = lazy(() => import('../pages/JobPost/JobPost'));
const JobEdit = lazy(() => import('../pages/JobPost/JobEdit'));
const OngoingProject = lazy(() => import('../pages/Project/OngoingProject'));
const ProjectDetail = lazy(() => import('../pages/Project/ProjectDetail'));
// const Offer = lazy(() => import('../pages/Project/Offer'));
const GiveOffer = lazy(() => import('../pages/Project/GiveOffer'));
const Wallet = lazy(() => import('../pages/Wallet/Wallet'));
const Topup = lazy(() => import('../pages/Wallet/Topup'));
const WithdrawalDetails = lazy(() =>
    import('../pages/Wallet/WithdrawalDetails')
);
const Talents = lazy(() => import('../pages/Talent/Talents'));
const TalentRequest = lazy(() => import('../pages/Talent/TalentRequest'));
const TalentDetails = lazy(() => import('../pages/Talent/TalentDetails'));
const Support = lazy(() => import('../pages/Support/Support'));
const TeamPricing = lazy(() => import('../pages/Team/Pricing'));
const InviteTeam = lazy(() => import('../pages/Team/InviteTeam'));
const InviteSuccess = lazy(() => import('../pages/Team/InviteSuccess'));
const TeamOnboard = lazy(() => import('../pages/Team/Onboard'));
const TeamCreateContract = lazy(() => import('../pages/Team/CreateContract'));
const TeamScheduleInvoice = lazy(() => import('../pages/Team/ScheduleInvoice'));
const TeamPayments = lazy(() => import('../pages/Team/Payments'));
const TeamPayroll = lazy(() => import('../pages/Team/Payroll'));
const TeamPayrollReview = lazy(() => import('../pages/Team/PayrollReview'));
const TeamTransactions = lazy(() => import('../pages/Team/Transactions'));

const AllRoutes = () => {

  const { theme } = useContext(ThemeContext);

  return (
    <Suspense fallback={<PageLoader />}>
      <BrowserRouter>
        <div data-theme={theme === 'dark' ? 'dark' : 'light'}>
          <div
            className={theme === 'dark' ? 'dark' : 'light'}
            id='app-container'
            data-theme={theme === 'dark' ? 'dark' : 'light'}
          >
              <LinkProvider component={RouterLink}>
              <Routes>
                <Route path='/' element={<Layout />}>
                  <Route index={true} element={<Overview />} />
                  <Route path='/invites/:id' element={<Invites />} />
                  <Route path='/hire-requests' element={<HireRequests />} />
                  {/* New wizard, alongside HireNowModal rather than replacing
                      it — nothing links here yet on purpose. */}
                  <Route path='/job-post' element={<JobPost />} />
                  <Route path='/job-post/:id' element={<JobEdit />} />
                  <Route path='/profile' element={<Profile />} />
                  <Route path='/project' element={<Project />} />
                  {/* <Route path='/project' element={<ProjectSetupLayout  />} /> */}
                  {/* <Route path='/project/offer' element={<Offer />} /> */}
                  {/* <Route path='/project/give-offer/:jobId/:userId' element={<GiveOffer />} /> */}
                  <Route path='/project/give-offer/:jobId/:userId' element={<ProjectSetupLayout />} />
                  <Route
                      path='/project/:id'
                      element={<ProjectDetail />}
                  />
                  {/* <Route
                  path='/project/ongoing-project'
                  element={<OngoingProject />}
                /> */}
                  <Route path='/wallet' element={<Wallet />} />
                  {/* <Route path='/wallet/deposit' element={<Topup />} /> */}
                  {/* <Route
                  path='/wallet/withdraw/details'
                  element={<WithdrawalDetails />}
                /> */}
                  <Route path='/support' element={<Support />} />
                  <Route path='/team/pricing' element={<TeamPricing />} />
                  <Route path='/team/invite' element={<InviteTeam />} />
                  <Route path='/team/invite-success' element={<InviteSuccess />} />
                  <Route path='/team/onboard' element={<TeamOnboard />} />
                  <Route path='/team/contracts/create' element={<TeamCreateContract />} />
                  <Route path='/team/invoices/schedule' element={<TeamScheduleInvoice />} />
                  <Route path='/team/payments' element={<TeamPayments />} />
                  <Route path='/team/payroll' element={<TeamPayroll />} />
                  <Route path='/team/payroll/review' element={<TeamPayrollReview />} />
                  <Route path='/team/transactions' element={<TeamTransactions />} />
                  <Route path='/hire-requests/:jobId' element={<TalentRequest />} />
                  <Route path='/hire-requests/:jobId/:userId' element={<TalentDetails />} />
                  <Route path='*' element={<NotFound />} />
                </Route>
              </Routes>
              </LinkProvider>
          </div>
        </div>
      </BrowserRouter>
    </Suspense>
  );
};

export default AllRoutes;
